import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { NOTIFICATIONS_API_URL } from '../api/notifications-api'
import { useRevalidateModules } from '@systemeio/util'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
export interface GetNotificationLinkResponse {
  link: string
}

export const useNotificationsActions = () => {
  const { fetcher: postFetcher } = useFetch<RequestMethodsEnum.post>({
    method: RequestMethodsEnum.post,
  })

  const { fetcher: linkFetcher } = useFetch<RequestMethodsEnum.get, GetNotificationLinkResponse>({
    method: RequestMethodsEnum.get,
  })

  const { revalidateModules } = useRevalidateModules()

  const markAllNotificationsAsRead = async () => {
    await postFetcher(`${NOTIFICATIONS_API_URL}/notifications/mark-all-as-read`)
    await revalidateModules([RequestModuleEnum.Notifications])
  }

  const markNotificationAsRead = async (id: string) => {
    await postFetcher(`${NOTIFICATIONS_API_URL}/notifications/${id}/mark-as-read`)
    await revalidateModules([RequestModuleEnum.Notifications])
  }

  const getNotificationLink = async (id: string) => {
    const data = await linkFetcher(`${NOTIFICATIONS_API_URL}/notifications/${id}`)
    await revalidateModules([RequestModuleEnum.Notifications])

    return data
  }

  return {
    markAllNotificationsAsRead,
    markNotificationAsRead,
    getNotificationLink,
  }
}
